export default([
  {country: 'Афганистан', code: '+93'},
  {country: 'Албания', code: '+355'},
  {country: 'Алжир', code: '+21'},
  {country: 'АмериканскоеСамоа', code: '+684'},
  {country: 'Андорра', code: '+376'},
  {country: 'Ангола', code: '+244'},
  {country: 'Ангуилла', code: '+1-264'},
  {country: 'АнтигуаиБарбуда', code: '+1-268'},
  {country: 'Аргентина', code: '+54'},
  {country: 'Армения', code: '+374'},
  {country: 'Аруба', code: '+297'},
  {country: 'Асеньон', code: '+247'},
  {country: 'Австралия', code: '+61'},
  {country: 'Австралийскиевнеш.террит-и', code: '+672'},
  {country: 'Австрия', code: '+43'},
  {country: 'Азербайджан', code: '+994'},
  {country: 'Азорскиео-ва', code: '+351'},
  {country: 'Багамы', code: '+1-242'},
  {country: 'Бахрейн', code: '+973'},
  {country: 'Бангладеш', code: '+880'},
  {country: 'Барбадос', code: '+1-246'},
  {country: 'Белоруссия', code: '+375'},
  {country: 'Бельгия', code: '+32'},
  {country: 'Белиз', code: '+501'},
  {country: 'Бенин', code: '+229'},
  {country: 'Бермудскиео-ва', code: '+1-441'},
  {country: 'Бутан', code: '+975'},
  {country: 'Боливия', code: '+591'},
  {country: 'БоснияиГерцеговина', code: '+387'},
  {country: 'Ботсвана', code: '+267'},
  {country: 'Бразилия', code: '+55'},
  {country: 'БританскиеВирджинскиео-ва', code: '+1-284'},
  {country: 'Бруней', code: '+673'},
  {country: 'Болгария', code: '+359'},
  {country: 'БуркинаФасо', code: '+226'},
  {country: 'Бурунди', code: '+257'},
  {country: 'Россия', code: '+7'},
  {country: 'Камбоджа', code: '+855'},
  {country: 'Камерун', code: '+237'},
  {country: 'КапеВерде', code: '+238'},
  {country: 'Каймановыо-ва', code: '+1-345'},
  {country: 'ЦАР', code: '+236'},
  {country: 'Чад', code: '+235'},
  {country: 'Чили', code: '+56'},
  {country: 'Китай', code: '+86'},
  {country: 'Рождественсткиео-ва', code: '+672'},
  {country: 'Кокосовыео-ва', code: '+672'},
  {country: 'Колумбия', code: '+57'},
  {country: 'СодружествосеверныхМарианскихо-вов', code: '+1-670'},
  {country: 'Коморскиео-ва', code: '+269'},
  {country: 'Конго', code: '+242'},
  {country: 'Дем.респ.Конго(бывш.Заир)', code: '+243'},
  {country: 'О-ваКука', code: '+682'},
  {country: 'КостаРика', code: '+506'},
  {country: 'Хорватия', code: '+385'},
  {country: 'Куба', code: '+53'},
  {country: 'Кипр', code: '+357'},
  {country: 'Чехия', code: '+420'},
  {country: 'Дания', code: '+45'},
  {country: 'ДиегоГарсиа', code: '+246'},
  {country: 'Джибути', code: '+253'},
  {country: 'Доминика', code: '+1-767'},
  {country: 'Доминиканскаяреспублика', code: '+1-809'},
  {country: 'ВосточныйТимор', code: '+62'},
  {country: 'Эквадор', code: '+593'},
  {country: 'Египет', code: '+20'},
  {country: 'Сальвадор', code: '+503'},
  {country: 'ЭкваториальнаяГвинея', code: '+240'},
  {country: 'Эритрия', code: '+291'},
  {country: 'Эстония', code: '+372'},
  {country: 'Эфиопия', code: '+251'},
  {country: 'Фарерскиео-ва', code: '+298'},
  {country: 'Фолклендскиео-ва', code: '+500'},
  {country: 'Фиджи', code: '+679'},
  {country: 'Финляндия', code: '+358'},
  {country: 'Франция', code: '+33'},
  {country: 'ФранцузскиеАнтиллы', code: '+590'},
  {country: 'ФранцузскаяГвиана', code: '+594'},
  {country: 'Французскаяполинезия', code: '+689'},
  {country: 'Габон', code: '+241'},
  {country: 'Гамбия', code: '+220'},
  {country: 'Грузия', code: '+995'},
  {country: 'Германия', code: '+49'},
  {country: 'Гана', code: '+233'},
  {country: 'Гибралтар', code: '+350'},
  {country: 'Греция', code: '+30'},
  {country: 'Гренландия', code: '+299'},
  {country: 'Гренада', code: '+1-473'},
  {country: 'Гуам', code: '+671'},
  {country: 'Гватемала', code: '+502'},
  {country: 'Гвинея', code: '+224'},
  {country: 'ГвинеяБиссау', code: '+245'},
  {country: 'Гайана', code: '+592'},
  {country: 'Гаити', code: '+509'},
  {country: 'Гондурас', code: '+504'},
  {country: 'Гонконг', code: '+852'},
  {country: 'Венгрия', code: '+36'},
  {country: 'Исландия', code: '+354'},
  {country: 'Индия', code: '+91'},
  {country: 'Индонезия', code: '+62'},
  {country: 'Иран', code: '+98'},
  {country: 'Ирак', code: '+964'},
  {country: 'Ирландия', code: '+353'},
  {country: 'Израиль', code: '+972'},
  {country: 'Италия', code: '+39'},
  {country: 'Берегслоновойкости', code: '+225'},
  {country: 'Ямайка', code: '+1-876'},
  {country: 'Япония', code: '+81'},
  {country: 'Иордания', code: '+962'},
  {country: 'Казахстан', code: '+7'},
  {country: 'Кения', code: '+254'},
  {country: 'Кирибати', code: '+686'},
  {country: 'СевернаяКорея', code: '+850'},
  {country: 'ЮжнаяКорея', code: '+82'},
  {country: 'Кувейт', code: '+965'},
  {country: 'Киргизстан', code: '+996'},
  {country: 'Лаос', code: '+856'},
  {country: 'Латвия', code: '+371'},
  {country: 'Ливан', code: '+961'},
  {country: 'Лессото', code: '+266'},
  {country: 'Либерия', code: '+231'},
  {country: 'Ливия', code: '+21'},
  {country: 'Лихтенштейн', code: '+41'},
  {country: 'Литва', code: '+370'},
  {country: 'Люксембург', code: '+352'},
  {country: 'Макао', code: '+853'},
  {country: 'Македония', code: '+389'},
  {country: 'Мадагаскар', code: '+261'},
  {country: 'Малави', code: '+265'},
  {country: 'Малайзия', code: '+60'},
  {country: 'Мальдивскиео-ва', code: '+960'},
  {country: 'Мали', code: '+223'},
  {country: 'Мальта', code: '+356'},
  {country: 'Маршалловыо-ва', code: '+692'},
  {country: 'Мартиника', code: '+596'},
  {country: 'Мавритания', code: '+222'},
  {country: 'Маврикий', code: '+230'},
  {country: 'Мексика', code: '+52'},
  {country: 'Микронезия', code: '+691'},
  {country: 'Монако', code: '+377'},
  {country: 'Монголия', code: '+976'},
  {country: 'Монсеррат', code: '+1-664'},
  {country: 'Молдавия', code: '+373'},
  {country: 'Марокко', code: '+212'},
  {country: 'Мозамбик', code: '+258'},
  {country: 'Мьянма', code: '+95'},
  {country: 'Намибия', code: '+264'},
  {country: 'Науру', code: '+674'},
  {country: 'Непал', code: '+977'},
  {country: 'Нидерланды', code: '+31'},
  {country: 'НидерландскиеАнтиллы', code: '+599'},
  {country: 'НоваяКаледония', code: '+687'},
  {country: 'НоваяЗеландия', code: '+64'},
  {country: 'Никарагуа', code: '+505'},
  {country: 'Нигер', code: '+227'},
  {country: 'Нигерия', code: '+234'},
  {country: 'Норфолкскиео-ва', code: '+672'},
  {country: 'Северо-Марианскиео-ва', code: '+670'},
  {country: 'Норвегия', code: '+47'},
  {country: 'Оман', code: '+968'},
  {country: 'Пакистан', code: '+92'},
  {country: 'Палау', code: '+680'},
  {country: 'Панама', code: '+507'},
  {country: 'ПапуаНоваяГвинея', code: '+675'},
  {country: 'Парагвай', code: '+595'},
  {country: 'Перу', code: '+51'},
  {country: 'Филипины', code: '+63'},
  {country: 'Польша', code: '+48'},
  {country: 'Португалия', code: '+351'},
  {country: 'ПуэртоРико', code: '+1-787'},
  {country: 'Катар', code: '+974'},
  {country: 'СанМарино', code: '+378'},
  {country: 'Реюнион', code: '+262'},
  {country: 'Румыния', code: '+40'},
  {country: 'Россия', code: '+7'},
  {country: 'Руанда', code: '+250'},
  {country: 'О-ваСвятойЕлены', code: '+247'},
  {country: 'СентПьер', code: '+508'},
  {country: 'СанМарино', code: '+39'},
  {country: 'СентТомиПринцип', code: '+239'},
  {country: 'СаудовскаяАравия', code: '+966'},
  {country: 'Сенегал', code: '+221'},
  {country: 'Сейшельскиео-ва', code: '+248'},
  {country: 'СьерраЛеоне', code: '+232'},
  {country: 'Сингапур', code: '+65'},
  {country: 'Словакия', code: '+421'},
  {country: 'Словения', code: '+386'},
  {country: 'Соломоновыо-ва', code: '+677'},
  {country: 'Сомали', code: '+252'},
  {country: 'ЮАР', code: '+27'},
  {country: 'Испания', code: '+34'},
  {country: 'ШриЛанка', code: '+94'},
  {country: 'Сент-КитсиНевис', code: '+1-869'},
  {country: 'СантаЛючия', code: '+1-758'},
  {country: 'СентВинцентиГренадины', code: '+1-784'},
  {country: 'Судан', code: '+249'},
  {country: 'Суринам', code: '+597'},
  {country: 'Свалбард', code: '+47'},
  {country: 'Свазиленд', code: '+268'},
  {country: 'Швеция', code: '+46'},
  {country: 'Швейцария', code: '+41'},
  {country: 'Сирия', code: '+963'},
  {country: 'Тайвань', code: '+886'},
  {country: 'Таджикистан', code: '+992'},
  {country: 'Танзания', code: '+255'},
  {country: 'Тайланд', code: '+66'},
  {country: 'Тоголезе', code: '+228'},
  {country: 'Токелау', code: '+690'},
  {country: 'Тонго', code: '+676'},
  {country: 'ТринидадиТобаго', code: '+1-868'},
  {country: 'Тунис', code: '+21'},
  {country: 'Турция', code: '+90'},
  {country: 'Туркменистан', code: '+993'},
  {country: 'Тувалу', code: '+688'},
  {country: 'Уганда', code: '+256'},
  {country: 'Украина', code: '+380'},
  {country: 'ОАЭ', code: '+971'},
  {country: 'Великобритания', code: '+44'},
  {country: 'Уругвай', code: '+598'},
  {country: 'Вирджинскиео-ва', code: '+1-340'},
  {country: 'США', code: '+1'},
  {country: 'Узбекистан', code: '+998'},
  {country: 'Вануату', code: '+678'},
  {country: 'Ватикан', code: '+39'},
  {country: 'Венесуэла', code: '+58'},
  {country: 'Вьетнам', code: '+84'},
  {country: ' ', code: '+681'},
  {country: 'ЗападнаяСахара', code: '+21'},
  {country: 'ЗападноеСамоа', code: '+685'},
  {country: 'СеверныйЙемен', code: '+967'},
  {country: 'ЮжныйЙемен', code: '+969'},
  {country: 'Югославия', code: '+381'},
  {country: 'Заир', code: '+243'},
  {country: 'Замбия', code: '+260'},
  {country: 'Занзибар', code: '+259'},
]);
